import React from "react";
import {CardBody, CardText, CardTitle} from "reactstrap";

const TemplateCard = ({data}) => {
  const {name, description, appliance} = data;
  return (
    <CardBody>
      <CardTitle tag="h4">
        Name <CardText>{name}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Description <CardText>{description}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Appliance <CardText>{appliance}</CardText>{" "}
      </CardTitle>
    </CardBody>
  );
};

export default TemplateCard;
